import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { styled } from "@mui/material/styles";
import _ from 'lodash';
import DoughnutChart from './DoughnutChart';
import PieChart from './PieChart';
import IntegrationReactSelect from './IntegrationReactSelect';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import '../css/AiDashboard.css';
// import createHistory from 'history/createBrowserHistory';


const styles = theme => ({
    button: {
      margin: theme.spacing.unit,
      width: '3rem',
    },
    input: {
      display: 'none',
    },
  });

  //ai dashboard page

class AiDashboard extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            error: 'bdsvj',
            genre: [],
            roomId: [],
            channel_id: [],
            userId: [],
            genreSelected:'',
            genreSelectedValue: {
                userPercent: 0,
                watchPercent: 0,
                channelPercent: 0
            },
            okasSelected: '',
            okasSelectedValue: {
                userPercent: 0,
                genrePercent: 0,
                watchPercent: 0
            },
            channelIdSelected: '',
            channelIdSelectedValue: {
                userPercent: 0,
                watchPercent: 0,
                boxPercent: 0
            },
            userIdSelected: '', 
            userIdSelectedValue: {
                genrePercent: 0,
                channelPercent: 0,
                watchPercent: 0
            } 
        }
    }
    componentWillMount(){
        this.fetchPrimaryData();       

      }

      componentDidMount(){
          console.log(this.state)
      }

      fetchPrimaryData = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`
        var headers = {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          'Authorization': tokenStored
      }
    
        fetch('/cloud/d2htabledata/' ,{
                method: "GET",
                headers: headers,
            })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
          console.log(data)
          var genre = [];
          var roomId =[];
          var channel_id = [];
          var userId = [];
        data.map((currentValue)=>{
            genre.push({
                label: currentValue.genre
            });
            userId.push({
                label: currentValue.userId
            });
            channel_id.push({
                label: currentValue.channel_id
            });
            roomId.push({
                label: currentValue.roomId});
          })

        genre = _.uniqBy(genre, 'label');  
        roomId = _.uniqBy(roomId, 'label');  
        userId = _.uniqBy(userId, 'label');  
        channel_id = _.uniqBy(channel_id, 'label');  

        this.setState({
            genre,
            userId,
            channel_id,
            roomId,
            genreSelected: genre[0].label,
            okasSelected: roomId[0].label,
            channelIdSelected: channel_id[0].label,
            userIdSelected: userId[0].label,
        },()=>console.log(this.state))

      })
      .catch(error => console.error(error))
      }

   
    okasFetch = () => {
        var roomId = '#123';
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`
        var headers = {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          'Authorization': tokenStored
      }
    
        fetch('/cloud/okascounttask/' ,{
            method: "POST",
            headers: headers,
            body: JSON.stringify({
              roomId
                  })
        })
           .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
  .then(data => {
    console.log(data)
    var maxNoOfGenre = 30;
    var maxNoOfUsers = 30;
    var maxWatchTime = 10000;
    var userPercent = _.round((data.Number_of_users/maxNoOfUsers)*100);
    var genrePercent = _.round((data.Number_of_Genre/maxNoOfGenre)*100);
    var watchPercent = _.round((data.Sum_of_Watch_Time/maxWatchTime)*100);
    this.setState({
        okasSelectedValue: {
            userPercent,
            genrePercent,
            watchPercent

          }
    })
  })
  .catch((err)=>{
    console.log(err)

  })
}

    genreFetch = (genre) => {
        var Genre = genre;
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`
        var headers = {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          'Authorization': tokenStored
      }
    
        fetch('/cloud/genrecounttask/' ,{
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                Genre
                  })
        })
           .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
  .then(data => {     
      var maxNoOfUsers = 30;
      var maxWatchTime = 10000;
      var maxNoOfChannelsViewed = 10;
      var userPercent = _.round((data.Total_No_Of_users/maxNoOfUsers)*100);
      var watchPercent = _.round((data.Watch_Time/maxWatchTime)*100);
      var channelPercent = _.round((data.Number_of_Channels_Viewed/maxNoOfChannelsViewed)*100);
      this.setState({
          genreSelectedValue: {
              userPercent: userPercent,
              watchPercent: watchPercent,
              channelPercent: channelPercent
            }
      },()=>{
          this.forceUpdate()
        })
    })
    .catch((err)=>{
      console.log(err)

      })
    }

    userFetch = (userId) => {
        var userId = userId;
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`
        var headers = {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          'Authorization': tokenStored
      }
    
        fetch('/cloud/usercounttask/' ,{
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                userId
                  })
        })
           .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
  .then(data => {
      console.log(data)
    var maxNoOfGenres = 30;
    var maxWatchTime = 10000;
    var maxNoOfChannels = 50;
    var watchPercent = _.round((data.Sum_of_Watch_Time/maxWatchTime)*100);
    var genrePercent = _.round((data.Number_of_Genre_Viewed/maxNoOfGenres)*100);
    var channelPercent = _.round((data.Number_of_Channels_Viewed/maxNoOfChannels)*100);
    this.setState({
        userIdSelectedValue: {
            watchPercent,
            channelPercent,
            genrePercent
          }
    },()=>{
        this.forceUpdate()
      })
  })
  .catch((err)=>{
    console.log(err)

  })
    }

    channelFetch = (channel_id) => {
        var channel_id = channel_id;
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`
        var headers = {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          'Authorization': tokenStored
      }
    
        fetch('/cloud/channelcounttask/' ,{
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                channel_id
                  })
        })
           .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
  .then(data => {
      console.log(data)
    var maxNoOfOkasBox = 50;
    var maxNoOfUsers = 30;
    var maxWatchTime = 10000;
    var userPercent = _.round((data.Number_of_users_final/maxNoOfUsers)*100);
    var watchPercent = _.round((data.Sum_of_Watch_Time/maxWatchTime)*100);
    var boxPercent = _.round((data.Number_of_Okas_Boxes/maxNoOfOkasBox)*100);
    this.setState({
        channelIdSelectedValue: {
            userPercent,
            watchPercent,
            boxPercent
          }
    })
    })
    .catch((err)=>{
      console.log(err)

      })
    }


    onSelectChange =(selectionType, data)=>{
        if(selectionType==='genre'){
            this.setState({
                genreSelected: data.value
            },()=>{
                this.genreFetch(data.value)
            })
        }
        else if(selectionType==='channel'){
            this.setState({
                genreSelected: data.value
            },()=>{
                this.channelFetch(data.value)
            })
        }
        else if(selectionType==="roomId"){
            this.setState({
                genreSelected: data.value
            },()=>{
                this.okasFetch(data.value);
            })
        }
        else if(selectionType==="userId"){
            this.setState({
                userIdSelected: data.value
            },()=>{
                this.userFetch(data.value);              
                
            })
        }
    }
    
    render(){
        const { classes } = this.props;
        return (
            <div className="dashboard-ai">
            <div className="dashbord-inner">
              <div className="dashboard-ai-heading">
              Welcome to OKAS CLOUD STUDIO!
              </div>
              <div className="dashboard-ai-subheading">
                  Tools from OKAS for great System Integrator, engaging with users and possibilites.                  
              </div>     
              <div className="row mt-3">
              <div className="col-md-6 col-lg-6 mb-3">
              <div class="card-custom ">
              <div className="card-top row">
              <div className="select-dropdown">
              {/* <IntegrationReactSelect 
                placeholder="Select Genre"
                multipleSelect={false}
                content={this.state.genre}
                onSelect={this.onSelectChange.bind(this,"genre")}
                IntegrationReactSelectNewLabel = "Select Genre Type"
            />             */}
                          <IntegrationReactSelectNew 
                placeholder="Select Genre"
                multipleSelect={false}
                content={this.state.genre}
                onSelect={this.onSelectChange.bind(this,"genre")}
                IntegrationReactSelectNewLabel = "Select Genre Type"
                // haveDefault={true}
                // defaultValue={this.state.genreSelected}
                someText={this.state.genreSelected}
            />                                                 
              </div>            
              </div>   
              <div className="row text-center NoMarginPadding">
            <div className="col-4 NoMarginPadding">
            <PieChart
                percent={this.state.genreSelectedValue.userPercent}
                chartWidth={window.innerWidth/10}
                strokeWidth={5}
                icon = "fa fa-user"
                label="No of Users"
                percentLabel ='Users'
                strokeColor='#f07e25'
               percentFontSize= {`${window.screen.availWidth/400}rem`}
                percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                percentLabelTop="62%"
                percentTop="16%"
            />
            </div>
            <div className="col-4 NoMarginPadding">
            <PieChart
                percent={this.state.genreSelectedValue.watchPercent}
                chartWidth={window.innerWidth/10}
                strokeWidth={5}
                icon = "fa fa-clock"
                label="Watch Time"
                percentLabel ='Hours'
                strokeColor='#f07e25'
                percentFontSize= {`${window.screen.availWidth/400}rem`}
                percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                percentLabelTop="62%"
                percentTop="16%"
            />            
            </div>
            <div className="col-4 NoMarginPadding">
            <PieChart
                percent={this.state.genreSelectedValue.channelPercent}
                chartWidth={window.innerWidth/10}
                strokeWidth={5}
                icon = "fa fa-desktop"
                label="No of Channels"
                percentLabel ='Channels'
                strokeColor='#f07e25'
                percentFontSize= {`${window.screen.availWidth/400}rem`}
                percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                percentLabelTop="62%"
                percentTop="16%"
            />             
            </div>
          </div> 
              <div className="custom-link">
              <a href="">&#60;See All&#62;</a>
              </div>
               </div>
              </div>  
              <div className="col-md-6 col-lg-6 mb-3">
              <div class="card-custom">
              <div className="card-top row">
              <div className="select-dropdown">
              <IntegrationReactSelect 
                placeholder="Select Channel"
                multipleSelect={false}
                content={this.state.channel_id}
                onSelect={this.onSelectChange.bind(this,"channel")}
                IntegrationReactSelectNewLabel = "Select Channel ID"
            />
              </div>          
              </div>   
              <div className="row text-center NoMarginPadding container-card">
                <div className="col-4 NoMarginPadding">
                <PieChart
                    percent={this.state.channelIdSelectedValue.userPercent}
                    chartWidth={window.innerWidth/10}
                    icon = "fa fa-user"
                    label="No of Users"
                    percentLabel ='Users'
                    strokeColor='#f07e25'
                    percentFontSize= {`${window.screen.availWidth/400}rem`}
                    percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                    percentLabelTop="62%"
                    percentTop="16%"
                />
                </div>
                <div className="col-4 NoMarginPadding">
                <PieChart
                    percent={this.state.channelIdSelectedValue.watchPercent}
                    chartWidth={window.innerWidth/10}
                    icon = "fa fa-clock"
                    label="Watch Time"
                    percentLabel ='Hours'
                    strokeColor='#f07e25'
                    percentFontSize= {`${window.screen.availWidth/400}rem`}
                    percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                    percentLabelTop="62%"
                    percentTop="16%"
                />          
                </div>
                <div className="col-4 NoMarginPadding">
                <PieChart
                    percent={this.state.channelIdSelectedValue.boxPercent}
                    chartWidth={window.innerWidth/10}
                    icon = "fa fa-box"
                    label="No of Boxes"
                    percentLabel ='Channels'
                    strokeColor='#f07e25'
                    percentFontSize= {`${window.screen.availWidth/400}rem`}
                    percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                    percentLabelTop="62%"
                    percentTop="16%"
                />          
                </div>
              </div> 
              <div className="custom-link">
              <a href="">&#60;See All&#62;</a>
              </div>
               </div>
              </div>  
              <div className="col-md-6 col-lg-6 mb-3">
              <div class="card-custom">
              <div className="card-top row">
              <div className="select-dropdown">
              <IntegrationReactSelect 
                placeholder="Select User"
                multipleSelect={false}
                content={this.state.userId}
                onSelect={this.onSelectChange.bind(this,"userId")}
                IntegrationReactSelectNewLabel = "Select User"
            />
              </div>               
              </div>   
              <div className="row text-center NoMarginPadding">
                <div className="col-4 NoMarginPadding">
                <PieChart
                    percent={this.state.userIdSelectedValue.watchPercent}
                    chartWidth={window.innerWidth/10}
                    icon = "fa fa-clock"
                    label="Watch Time"
                    percentLabel ='Hours'
                    strokeColor='#f07e25'
                    percentFontSize= {`${window.screen.availWidth/400}rem`}
                    percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                    percentLabelTop="62%"
                    percentTop="16%"
                />   
                </div>
                <div className="col-4 NoMarginPadding">
                <PieChart
                    percent={this.state.userIdSelectedValue.genrePercent}
                    chartWidth={window.innerWidth/10}
                    icon = "fa fa-info"
                    label="No of Genres"
                    percentLabel ='Genres'
                    strokeColor='#f07e25'
                    percentFontSize= {`${window.screen.availWidth/400}rem`}
                    percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                    percentLabelTop="62%"
                    percentTop="16%"
                />             
                </div>
                <div className="col-4 NoMarginPadding">
                <PieChart
                    percent={this.state.userIdSelectedValue.channelPercent}
                    chartWidth={window.innerWidth/10}
                    icon = "fa fa-desktop"
                    label="No of Channels"
                    percentLabel ='Channels'
                    strokeColor='#f07e25'
                    percentFontSize= {`${window.screen.availWidth/400}rem`}
                    percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                    percentLabelTop="62%"
                    percentTop="16%"
                />          
                </div>
              </div> 
              <div className="custom-link">
              <a href="">&#60;See All&#62;</a>
              </div>
               </div>
              </div>  
              <div className="col-md-6 mb-3">
              <div class="card-custom">
              <div className="card-top row">
              <div className="select-dropdown">
              <IntegrationReactSelect 
                placeholder="Select  Box"
                multipleSelect={false}
                content={this.state.roomId}
                onSelect={this.onSelectChange.bind(this,"roomId")}
                IntegrationReactSelectNewLabel = "Select  Box"
            />
              </div>             
              </div>   
              <div className="row text-center  NoMarginPadding">               
                <div className="col-4 NoMarginPadding">
                <PieChart
                    percent={this.state.okasSelectedValue.genrePercent}
                    chartWidth={window.innerWidth/10}
                    icon = "fa fa-info"
                    label="No of Genres"
                    percentLabel ='Genres'
                    strokeColor='#f07e25'
                    percentFontSize= {`${window.screen.availWidth/400}rem`}
                    percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                    percentLabelTop="62%"
                    percentTop="16%"
                />           
                </div>
                <div className="col-4 NoMarginPadding">
                <PieChart
                    percent={this.state.okasSelectedValue.userPercent}
                    chartWidth={window.innerWidth/10}
                    icon = "fa fa-users"
                    label="No of Users"
                    percentLabel ='Users'
                    strokeColor='#f07e25'
                    percentFontSize= {`${window.screen.availWidth/400}rem`}
                    percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                    percentLabelTop="62%"
                    percentTop="16%"
                />
                </div>
                <div className="col-4 NoMarginPadding">
                <PieChart
                    percent={this.state.okasSelectedValue.watchPercent}
                    chartWidth={window.innerWidth/10}
                    icon = "fa fa-clock"
                    label="Watch Time"
                    percentLabel ='Hours'
                    strokeColor='#f07e25'
                    percentFontSize= {`${window.screen.availWidth/400}rem`}
                    percentLabelSize= {`${window.screen.availWidth/1920}rem`}
                    percentLabelTop="62%"
                    percentTop="16%"
                />          
                </div>
              </div> 
              <div className="custom-link">
              <a href="">&#60;See All&#62;</a>
              </div>
               </div>
              </div>              
              </div>         
            </div>
            <div className="modal">
                 <DoughnutChart />        
            </div>
            </div>
        );
    }
}

AiDashboard.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default styled(styles)(AiDashboard);
